import React from 'react';
import classnames from 'classnames';
import { withMatureContext } from '@wix/da-react-context/pkg/MatureContext';
import DOMPurify from 'isomorphic-dompurify';
import { useSafeUrlHandler } from '../SafeUrlModal/hooks/useSafeUrlHandler';

import s from './LegacyTextRenderer.scss';

export type LegacyTheme =
  | 'default'
  | 'journal'
  | 'status'
  | 'short-status'
  | 'commission'
  | 'comments'
  | 'literature-description'
  | 'extended-details'
  | 'poll-answer';

export interface Props {
  html?: string;
  className?: string;
  theme?: LegacyTheme;
  showMatureContent?: boolean;
  disableStyles?: boolean;
  withSafetyCheckModal?: boolean;
}

function createMarkup(text: string) {
  return {
    __html: DOMPurify.sanitize(text, {
      FORCE_BODY: true,
      ADD_TAGS: ['iframe'],
    }),
  };
}

export const LegacyTextRenderer = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      html,
      className,
      theme,
      showMatureContent,
      disableStyles,
      withSafetyCheckModal,
    },
    ref
  ) => {
    const safeUrlHandler = useSafeUrlHandler();

    if (!html) {
      return null;
    }

    return (
      <>
        <div
          className={classnames(
            'legacy-journal',
            !disableStyles && theme && s['legacy'],
            !disableStyles && theme && s[theme],
            !showMatureContent && 'maturefilter',
            className
          )}
          dangerouslySetInnerHTML={createMarkup(html)}
          ref={ref}
          onClickCapture={withSafetyCheckModal ? safeUrlHandler : undefined}
        />
      </>
    );
  }
);

LegacyTextRenderer.displayName = 'LegacyTextRenderer';

export default withMatureContext(LegacyTextRenderer);
